<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { bindClient } from "@/api/finance/freight";

import cTable from "@/base/common/index";

export default {
  props: {
    rows: {
      type: Object
    }
  },
  components: {
    cTable
  },
  methods: {
    export() {
      let data = {
        id: this.rows.id,
        export: 1
      };
      bindClient(data).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
          duration: res.data.status ? 2 : 5
        });
        if (res.data.status) window.open(this.$globalUrl + res.data.payload);
      });
    }
  },
  data() {
    return {
      methods: {
        list: () => {
          return bindClient(this.rows.id);
        }
      },
      modals: {},
      config: {
        slot: "div",
        rows: this.rows
      },
      footer: { show: () => false },
      header: {
        config: {
          custom: false
        },
        searchs: []
      },
      fields: [
        {
          name: () => this.$t("clientName"),
          key: "account",
          align: "left",
          width: 150
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          align: "left",
          width: 150
        },
        {
          name: () => this.$t("exlType"),
          key: "status",
          align: "center",
          width: 80,
          methods: {
            render({ value }) {
              return this.$t(value);
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          width: 170,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        }
      ]
    };
  }
};
</script>
